import { render, staticRenderFns } from "./SupportFooterPlayground.vue?vue&type=template&id=4e67732f&scoped=true&"
import script from "./SupportFooterPlayground.vue?vue&type=script&lang=js&"
export * from "./SupportFooterPlayground.vue?vue&type=script&lang=js&"
import style0 from "./SupportFooterPlayground.vue?vue&type=style&index=0&id=4e67732f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67732f",
  null
  
)

export default component.exports